// Product reviews data
export const productReviews = {
  'brass-plank': [
    {
      name: 'Marcello Trinchero',
      rating: 5,
      date: 'January 14, 2021',
      text: "Un'idea intelligente, comoda ed elegante per prevenire la diffusione del covid-19 tra strumentisti ad ottone",
      source: 'Facebook'
    },
    {
      name: 'Iain H Hunter',
      rating: 5,
      date: 'December 12, 2020',
      text: 'The Brass Plank is a new great innovative and practical tool for all brass players. Designed to collect the condensation from our instruments, easily stored and cleaned. Highly recommended.',
      source: 'Facebook'
    },
    {
      name: 'José Juan Hernández',
      rating: 5,
      date: 'March 23, 2021',
      text: 'Es un producto muy práctico, fácil de transportar y da una buena imagen para el momento de un concierto o recital.',
      source: 'Facebook'
    },
    {
      name: 'Carlos Parra Morales',
      rating: 5,
      date: 'January 21, 2021',
      text: 'Soluciona nuestros pesares de instrumentistas de metal. Cómprenlo porque también es muy práctico.',
      source: 'Facebook'
    },
    {
      name: 'Luis Carlos Hernández',
      rating: 5,
      date: 'December 17, 2020',
      text: 'Hoy estrenando esta herramienta muy útil para nuestro instrumento fácil de armar y transportar, ademas de ayudarnos a esa incomodidad de dejar el suelo mojado, 100% recomendada 👍🎺',
      source: 'Facebook'
    },
    {
      name: 'Tomás A. Guillén Ayala',
      rating: 5,
      date: 'December 10, 2020',
      text: 'Es muy útil para no ensuciar el suelo de tu casa o de tu lugar de trabajo, es antibacterial, por lo tanto muy segura de usar, se limpia fácilmente y se transporta fácil.',
      source: 'Facebook'
    },
    {
      name: 'Jovany Cruz',
      rating: 5,
      date: 'October 20, 2020',
      text: 'Un producto necesario en estos tiempos, yo lo adquirí por cuidar a mi familia en mi estudio diario y ahora es una herramienta que en la sinfónica esta funcionando muy bien, el agua que sale de la trompeta se seca en 5 minutos y es fácil de limpiar lo recomiendo al 100%.',
      source: 'Facebook'
    },
    {
      name: 'Oskar Martinez',
      rating: 5,
      date: 'October 18, 2020',
      text: 'Muy recomendable... Es práctico, ligero, higiénico y fácil de usar, te evitas de andar limpiando el suelo en el lugar de trabajo o estudio 🎺',
      source: 'Facebook'
    },
    {
      name: 'Jorge Martinez',
      rating: 5,
      date: 'December 18, 2020',
      text: 'Ey amigos!! Compren éste excelente accesorio! Es una maravilla y aún más en ésta nueva modalidad! Muchas gracias a mi amigo y colega Isaías Jiménez.',
      source: 'Facebook'
    },
    {
      name: 'Oskar Racso',
      rating: 5,
      date: 'December 29, 2020',
      text: 'Les recomiendo mucho este excelente accesorio muy útil en esta época es fácil de usar y transportar gracias Brass Plank',
      source: 'Facebook'
    },
    {
      name: 'Tomas Rodriguez Silva',
      rating: 5,
      date: 'December 11, 2020',
      text: 'Ayuda a mantener el lugar de estudio y de trabajo ausente de humedad producto de la condensación al ejecutar el instrumento. Muy cómodo de transportar.',
      source: 'Facebook'
    }
  ],
  'noteturner': [
    {
      name: 'Scott Grimaldi',
      rating: 5,
      date: 'June 24, 2025',
      text: "The NoteTurner is a GREAT product! I ordered two of them to use in a current pit orchestra gig that I'm playing alto sax and tenor sax in. As a woodwinds player, I appreciate the fact that it allows me to quickly turn pages (forward and back) by pushing a button from either of my saxophones (when reading music on forScore from my iPad), without resorting to a foot pedal page turner. In addition, Isaias (the inventor) has consistently responded to my questions on IG in a timely fashion, with his very useful video tutorials and voice messages. I'll definitely be using the NoteTurner on similar future gigs.",
      source: 'Verified Purchase'
    },
    {
      name: 'Frank Wommelsdorff',
      rating: 5,
      date: 'July 3, 2025',
      text: 'I had a problem with my newly purchased Note Turner. JiMendez responded quickly and sent an instructional video so I could solve the problem. Thanks for the quick and easy to understand help. NoteTurner is a small and very well functioning bluetooth device. It is significantly easier to work with than the pedals I have used before. I highly recommend JiMendez',
      source: 'Verified Purchase'
    },
    {
      name: 'Bill Nelson',
      rating: 5,
      date: 'August 5, 2025',
      text: "I had a problem with my first one and Ji Jimenez sent me a replacement free of charge. I received my second one and it is working wonderfully! I'm very pleased with the product and the company!",
      source: 'Verified Purchase'
    },
    {
      name: 'Josh Cameron',
      rating: 5,
      date: 'May 20, 2025',
      text: 'This page turner is great! Connected easily to my iPad and works great with my pdf reading app and the camera function as well! Easy to operate while I play and means less clutter on the stage or in the pit.',
      source: 'Verified Purchase'
    },
    {
      name: 'Linda',
      rating: 5,
      date: 'June 25, 2025',
      text: 'I am using this noteturner on my alto sax and accordion. I purchased more Velcro strips for my other 12 accordions so I can move the noteturner to the accordion I am currently playing! They work great!',
      source: 'Verified Purchase'
    },
    {
      name: 'Haakon Ballangrud',
      rating: 5,
      date: 'July 8, 2025',
      text: 'I have received a pageturner for Trumpet. It works well and I am very happy with the good support they give me. I recomend this product to anyone. Best regards from Norway',
      source: 'Verified Purchase'
    },
    {
      name: 'Ray Nettleship',
      rating: 5,
      date: 'August 9, 2025',
      text: 'Great product and communication from the vendor. Highly recommended',
      source: 'Verified Purchase'
    },
    {
      name: 'Yves Camus',
      rating: 5,
      date: 'August 6, 2025',
      text: 'Tourne pages fonctionne très bien, je recommande.... France',
      source: 'Verified Purchase'
    },
    {
      name: 'Dennis K',
      rating: 5,
      date: 'September 8, 2025',
      text: 'This is a good device and functions well in most cases, but do know, that the page turn is a swipe gesture not a button press and that may not be of use in certain functions such as mobilesheets with vertical scrolling while using pages cropped to half a page or less. The attachment is easy and sturdy.',
      source: 'Verified Purchase'
    },
    {
      name: 'Eijun',
      rating: 5,
      date: 'September 7, 2025',
      text: 'The device arrived today! I immediately connected it to my ipad and tested it. I usually use an app "Piascore". I would like to view sheet music by scrolling vertically, is this supported?',
      source: 'Verified Purchase'
    },
    {
      name: 'Will',
      rating: 5,
      date: 'August 23, 2025',
      text: "It all seems good. I use a foot pedal but still, occasionally miss it while reading. However, the power supply battery seems like it could be problematic. Does this device have a warning light for a low battery, so you don't run out of juice during performance?",
      source: 'Verified Purchase'
    },
    {
      name: 'Steve Tippett',
      rating: 5,
      date: 'May 5, 2025',
      text: 'I received the noteturner today. How long will the battery typically last, and how do I change the battery, when it needs to be replaced?',
      source: 'Verified Purchase'
    }
  ]
};

export function getProductReviews(slug) {
  return productReviews[slug] || [];
}

export function getAverageRating(slug) {
  var reviews = productReviews[slug] || [];
  if (reviews.length === 0) return 0;
  var total = 0;
  for (var i = 0; i < reviews.length; i++) {
    total += reviews[i].rating;
  }
  return (total / reviews.length).toFixed(1);
}
